import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { report_bill_lang } from "../../language/report_bill";
import * as moment from 'moment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { thLocale } from 'ngx-bootstrap/locale';
defineLocale('engb', enGbLocale);
defineLocale('th', thLocale);
declare var url; declare var report_url;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
  TotalPrice: number;
}

class report {
  customer_id: string;
  customer_name: string;
  place_id: string;
  place_address: string;
  place_type_desc: string;
  fee_type_description: string;
  fee_type_unit: string;
  inform_price: number;
  total_price: number;
}

@Component({
  selector: 'app-report-bill-cancel',
  templateUrl: './report-bill-cancel.component.html',
  styleUrls: ['./report-bill-cancel.component.scss']
})
export class ReportBillCancelComponent implements OnInit {
  lang = localStorage.getItem('lang') == "EN" ? "EN" : "TH";
  language: any;
  counter = 0;
  months = [
    // {value:0,name_th:'all',n},
    { value: 1, name: { TH: 'มกราคม', EN: "January" } },
    { value: 2, name: { TH: 'กุมภาพันธ์', EN: "February" } },
    { value: 3, name: { TH: 'มีนาคม', EN: "March" } },
    { value: 4, name: { TH: 'เมษายน', EN: "April" } },
    { value: 5, name: { TH: "พฤษภาคม", EN: "May" } },
    { value: 6, name: { TH: "มิถุนายน", EN: "June" } },
    { value: 7, name: { TH: "กรกฏาคม", EN: "July" } },
    { value: 8, name: { TH: "สิงหาคม", EN: "August" } },
    { value: 9, name: { TH: "กันยายน", EN: "September" } },
    { value: 10, name: { TH: "ตุลาคม", EN: "October" } },
    { value: 11, name: { TH: "พฤศจิกายน", EN: "November" } },
    { value: 12, name: { TH: "ธันวาคม", EN: "December" } }
  ];
  types = [
    { value: 1, name: { TH: 'รายวัน', EN: "Report of Daily" } },
    { value: 2, name: { TH: 'รายเดือน', EN: "Report of Month" } },
    { value: 3, name: { TH: 'รายปี', EN: "Report of Year" } },
  ]

  daysInmonth;
  days;
  type = 2;
  day = new Date().getDay() + 1;
  month = new Date().getMonth() + 1;
  year = new Date().getFullYear();
  years: any;
  count = 0;
  interval: any;
  ShowDay: boolean = true;
  ShowMonth: boolean = true;
  ShowYear: boolean = true;
  ShowTable: boolean = false;
  ShowInvoice: boolean = false;
  ShowInformation: boolean = false;
  isLoading = false;
  search_report = '';
  all_reports: any;
  inform_count = 0;
  inform_price = 0;
  inform_price_value = '';
  report = { customer_name: "", place_id: "", place_address: "", place_type_description: "", fee_type_description: "", fee_type_unit: "", request_general_id: "", customer_id: "" };
  request_general: [];
  reports_invoices: any;
  invoices: any;
  all_reports_invoice: any;
  report_invoice = { bill_id: "", user_id: "", create_datetime: "", discount: "", total_price: "", fee_description: "", payment_description: "" };
  request_general_id = '';
  submitted = false;

  municipality_id = '';
  token = '';
  database = '';
  dtOptions: DataTables.Settings = {};
  reports: report[];

  constructor(
    private http: HttpClient,
    private service: MyserviceService,
    private chRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private localeService: BsLocaleService,
    private router: Router,
    private modalService: BsModalService) {
    this.language = report_bill_lang[this.lang];
  }

  ngOnInit() {

    if (parseInt(this.year.toString()) < 2500) {
      this.year = this.year + 543;
    }

    this.years = [];
    for (var i = 0; i < 5; i++) {
      this.years.push(this.year - i);
    }

    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }

    this.daysInmonth = new Date(parseInt(year_db.toString(), 10), parseInt(this.month.toString(), 10), 0).getDate();
    this.daysInmonth = parseInt(this.daysInmonth.toString(), 10);
    this.days = [];
    for (var i = 0; i <= this.daysInmonth - 1; i++) {
      this.days.push(i + 1);
    }

    this.ShowYear = true;
    this.ShowMonth = true;
    this.ShowDay = false;
    // this.refreshData();

    if (sessionStorage.getItem('municipality') != undefined) {
      this.database = JSON.parse(sessionStorage.getItem('municipality')).municipality_id + '_fee'
    }

    if (sessionStorage.getItem('token') != undefined) {
      this.token = sessionStorage.getItem('token');
    }

    this.ShowInvoice = false;
    this.ShowInformation = false;
    this.isLoading = false;
    this.ShowTable = true;
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      language: {
        emptyTable: 'NO Records',
        zeroRecords: '',
      },
      ajax: (dataTablesParameters: any, callback) => {
        console.log('reports-new/get_reports_all_bill_to_datatable')
        that.http
          .post<DataTablesResponse>(
            url + 'reports-new/get_reports_all_bill_to_datatable',
            dataTablesParameters, {
            headers: new HttpHeaders({
              'Content-Type': 'application/json; charset=utf-8',
              'x-access-token': this.token,
              'database': this.database,
              'report_type': this.type.toString(),
              'type': this.type.toString(),
              'day': (this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString(),
              'month': (this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString(),
              'year': (this.year - 543).toString(),
              'cancel': 'true'
            })
          }
          ).subscribe(resp => {
            console.log(resp);
            that.reports = resp.data.map((item) => {
              item.create_datetime = +moment(item.create_datetime).format("YYYY") <= new Date().getFullYear() ? moment(item.create_datetime).add(543, 'years').format("DD/MM/YYYY HH:mm:ss") : moment(item.create_datetime).format("DD/MM/YYYY HH:mm:ss")
              var formatter = new Intl.NumberFormat('th-TH', {
                style: 'currency',
                currency: 'THB',
              });

              this.inform_count = resp.recordsTotal;
              this.inform_price = resp.TotalPrice;
              this.inform_price_value = formatter.format(this.inform_price) + ' บาท';
              return item;
            });
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [{ data: 'cm.customer_id' }, { data: 'cm.customer_name' }, { data: 'fm.place_id' }, { data: 'cp.place_address' },
       { data: 'fy.fee_type_description' }, { data: 'fy.fee_type_unit' }, { data: '' }, { data: '' }]
    };
    // { data: 'pty.place_type_description' },
    this.route.queryParams.subscribe(params => {
      this.lang = params['lang'];
      if (this.lang != 'EN' && this.lang != 'TH') {
        this.lang = localStorage.getItem('lang') == 'EN' ? 'EN' : 'TH';
        this.language = report_bill_lang[this.lang];
      } else {
        this.language = report_bill_lang[this.lang];
        localStorage.setItem('lang', this.lang);
      }
    });
  }


  refreshData() {
    this.inform_count = 0;
    this.inform_price_value = "0.0";
    this.ShowTable = false;
    this.isLoading = true;
    this.ShowInvoice = false;
    this.ShowInformation = false;

    setTimeout(() => {
      this.ShowTable = true;
      this.isLoading = false;
    }, 100);
  }


  typeChange() {
    switch (this.type.toString()) {
      case '1':
        this.ShowYear = true;
        this.ShowMonth = true;
        this.ShowDay = true;
        break;
      case '2':
        this.ShowYear = true;
        this.ShowMonth = true;
        this.ShowDay = false;
        break;
      case '3':
        this.ShowYear = true;
        this.ShowMonth = false;
        this.ShowDay = false;
        break;
      case '99':
      case '98':
      case '97':
        this.ShowYear = false;
        this.ShowMonth = false;
        this.ShowDay = false;
        break;
    }
  }

  monthChange() {
    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }

    this.daysInmonth = new Date(parseInt(year_db.toString(), 10), parseInt(this.month.toString(), 10), 0).getDate();
    this.daysInmonth = parseInt(this.daysInmonth.toString(), 10);
    this.days = [];
    for (var i = 0; i <= this.daysInmonth - 1; i++) {
      this.days.push(i + 1);
    }
  }

  show_information(item) {
    console.log(item);
    this.ShowInformation = true;
    this.ShowInvoice = false;
    this.ShowTable = false;
    this.report.customer_id = item.customer_id;
    this.report.customer_name = item.customer_name;
    this.report.place_id = item.place_id;
    this.report.place_address = item.place_address;
    this.report.place_type_description = item.place_type_description;
    this.report.fee_type_description = item.fee_type_description;
    this.report.fee_type_unit = item.fee_type_price + ' ' + item.fee_type_unit;

    this.report_invoice = { bill_id: "", user_id: "", create_datetime: "", discount: "", total_price: "", fee_description: "", payment_description: "" };
    this.isLoading = true;
    this.search_report = "";
    this.service.postData({ bill_id: item.bill_id, cancel: true }, "reports-new/get_reports_bill").then((result: any) => {
      this.all_reports_invoice = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""));
      this.reports_invoices = this.all_reports_invoice.filter((item) => {
        var res: any;
        res = item;

        var xy = 0;
        xy = parseInt(moment(item.create_datetime).format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        res.create_datetime = moment(item.create_datetime).format("DD/MM/") + xy;

        xy = 0;
        xy = parseInt(moment(item.due_date).format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        res.due_date = moment(item.due_date).format("DD/MM/") + xy;
        res.status_code = item.payment_description;
        return res;
      });
      this.all_reports_invoice = this.reports_invoices
      this.isLoading = false;
    }, (err) => {
      this.isLoading = false;
      Swal.fire({
        title: this.language.no_internet_alert,
        text: '',
        type: 'error',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      });
    })
  }

  back() {
    this.ShowInformation = false;
    this.ShowTable = true;
    this.report = { customer_name: "", place_id: "", place_address: "", place_type_description: "", fee_type_description: "", fee_type_unit: "", request_general_id: "", customer_id: "" };
  }

  onSearch_invoice(event) {
    this.reports_invoices = this.all_reports_invoice.filter((item) => {
      return compare(item.invoice_id) || compare(item.fee_description) || compare(item.create_datetime) || compare(item.due_date) || compare(item.total_price) || compare(item.status_code) || compare(item.user_id);
    })
    function compare(type) {
      if (type != undefined) {
        return type.toString().toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
      }
      else {
        return [];
      }

    }
  }

  onSearch_place(event) {
    this.reports = this.all_reports.filter((item) => {
      return compare(item.place_id) || compare(item.place_address) || compare(item.place_type_description) || compare(item.fee_type_description) || compare(item.fee_type_unit) || compare(item.customer_id) || compare(item.customer_name);
    })
    function compare(type) {
      if (type != undefined) {
        return type.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
      }
      else {
        return [];
      }

    }
  }

  print_invoice(item) {
    const municipality_id = this.service.getDatabase().substring(0, 5);
    const bill_id = item.bill_id;
    this.service.postData({ bill_id }, "invoice/print-bill").then((result) => {
      window.open(report_url + "print-bill?bill_id=" + bill_id + "&municipality_id=" + municipality_id, "_blank");
    })
  }
  download_excel() {
    const municipality_id = this.service.getDatabase().substring(0, 5);
    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }

    switch (this.type.toString()) {
      case '1':
        var dateString = ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + '-' + ((this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString()) + '-' + (year_db.toString());
        var momentObj = moment(dateString, 'MM-DD-YYYY');
        window.open(report_url + "print-report-bill-cancel-excel?datetime=" + momentObj.format('X') + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id, "_blank");
        break;
      case '2':
        window.open(report_url + "print-report-bill-cancel-excel?month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id, "_blank");
        break;
      case '3':
        window.open(report_url + "print-report-bill-cancel-excel?year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id, "_blank");
        break;;
    }
  }
  print_report() {
    const municipality_id = this.service.getDatabase().substring(0, 5);
    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }

    switch (this.type.toString()) {
      case '1':
        var dateString = ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + '-' + ((this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString()) + '-' + (year_db.toString());
        var momentObj = moment(dateString, 'MM-DD-YYYY');
        window.open(report_url + "print-report-bill-cancel?datetime=" + momentObj.format('X') + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id, "_blank");
        break;
      case '2':
        window.open(report_url + "print-report-bill-cancel?month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id, "_blank");
        break;
      case '3':
        window.open(report_url + "print-report-bill-cancel?year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id, "_blank");
        break;;
    }

  }

  show_invoice(item) {
    this.ShowInvoice = true;
    this.service.postData({ customer_id: this.report.customer_id }, "request-general/get").then((result: any) => {
      this.request_general = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""))
      this.service.postData({ invoice_id: item.invoice_id }, "invoice/get-invoice-detail").then((result2: any) => {
        this.invoices = JSON.parse(JSON.stringify(result2.data).replace(/\:null/gi, "\:\"\""));
        this.invoices = this.invoices.filter((item) => {
          var res: any;
          res = item;

          var xy = 0;
          xy = parseInt(moment(item.create_datetime).format('YYYY'));

          if (xy < 2500) {
            xy = xy + 543;
          }

          res.create_datetime = moment(item.create_datetime).format("DD/MM/") + xy;

          xy = 0;
          xy = parseInt(moment(item.due_date).format('YYYY'));

          if (xy < 2500) {
            xy = xy + 543;
          }

          res.due_date = moment(item.due_date).format("DD/MM/") + xy;
          res.status_code = (item.status_code == '02' ? 'ชำระแล้ว' : 'ยังไม่ชำระ')
          return res;
        });
        console.log(this.invoices)
        this.isLoading = false;
      })
    })
  }

  delete() {
    if (this.invoices.length > 0) {
      this.submitted = true;
      if (this.request_general_id != '' && this.request_general_id != undefined) {
        Swal.fire({
          title: this.language.confirm_delete,
          text: this.language.warining_delete,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.language.want_delete,
          cancelButtonText: this.language.close
        }).then((result) => {
          if (result.value) {
            this.service.postData({ fee_id: this.invoices[0].fee_id, bill_id: undefined, request_general_id: this.request_general_id }, "invoice/cancel-invoice").then(result => {
              this.isLoading = false;
              Swal.fire({
                title: this.language.deleted,
                text: '',
                type: 'success',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 2000
              }).then((result) => {
                this.refreshData();
              })
            }, err => {
              window.location.href = this.service.start_host
              this.isLoading = false;
            })
          }
        });
      }
    }

  }

}
